// eslint-disable-next-line import/prefer-default-export
export const dateFormat = 'll';
export const inputDateFormat = 'YYYY-MM-DD';
